import * as Yup from "yup";

export const DefaultBindingProduct = "#default";

export const BindingValidationSchema = Yup.object().shape({
    isDefaultProduct: Yup.bool().notRequired(),
    pricingGroup: Yup.mixed().notRequired(),
    product: Yup.string().label('Product')
        .when('isDefaultProduct',{
            is: false,
            then: Yup.string().required('Please enter product/crop name'),
            otherwise: Yup.string().nullable().notRequired()
        }),
    cost: Yup.number().required('Enter cost for product in the region').label('Cost').min(0,"Invalid product cost. Cost should be greater than 0")
});



// WEBPACK FOOTER //
// ./src/views/Extras/Services/USSDServices/USSDServicesCommon.js